
import React from 'react'
import icon from './svgs/search.svg'
import { BaseIcon } from './_base'

export const SearchIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
